import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import InvitationList from '../../invitationList';

function ReceivedInvitationsView(props) {
  if (isEmpty(props.invitations)) {
    return null;
  }

  return (
    <div className="mb-5">
      <div className="flex-container mb-3">
        <h2 className="mb-0">
          <Translate value={props.isSuggestion ? 'invitation.suggestion.title' : 'invitation.received.title'}/>
        </h2>
      </div>
      <div>
        <InvitationList
          isSuggestion={props.isSuggestion}
          invitations={props.invitations}
          onAccept={props.onAcceptInvitation}
          onReject={props.onOpenRejectionReasonModal}
        />
      </div>
    </div>
  );
}

ReceivedInvitationsView.defaultPops = {
  isSuggestion: false
};

ReceivedInvitationsView.propTypes = {
  onOpenRejectionReasonModal: PropTypes.func.isRequired,
  onAcceptInvitation: PropTypes.func.isRequired,
  invitations: PropTypes.arrayOf(PropTypes.object).isRequired,
  isSuggestion: PropTypes.bool
};

export default ReceivedInvitationsView;
